document.addEventListener("DOMContentLoaded", function () {
  const dataEl = document.getElementById("ProductFormData");
  if (!dataEl) return;

  const { variants, numOptions, defaultVariantId, moneyFormat } = JSON.parse(dataEl.textContent);
  const variantInput = document.getElementById("SelectedVariantId");

    function updatePreorderProperty(match) {
    if (!variantInput) return;
    const form = variantInput.form;
    if (!form) return;

    let input =
      form.querySelector('#PreOrderProperty') ||
      form.querySelector('input[name="properties[Pre-order]"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.id = 'PreOrderProperty';
      form.appendChild(input);
    }

    const isPreorder =
      (match.inventory_quantity || 0) < 1 &&
      match.inventory_policy === 'continue';

    if (isPreorder) {
      input.name = 'properties[Pre-order]';

      let value = 'Ship Date TBD';
      if (match.estimated_ship_date) {
        const d = new Date(match.estimated_ship_date + 'T00:00:00');
        const opts = { month: 'short', day: 'numeric' };
        value = 'Est. to Ship ' + d.toLocaleDateString('en-US', opts);
      }
      input.value = value;
    } else {
      input.removeAttribute('name');
      input.value = '';
    }
  }


  function getVariantIdFromURL() {
    const params = new URLSearchParams(window.location.search);
    return params.get("variant");
  }

  function getSelectedOptions() {
    const selected = [];
    for (let i = 0; i < numOptions; i++) {
      const checked = document.querySelector(`input[name="option-${i}"]:checked`);
      selected.push(checked ? checked.value : null);
    }
    return selected;
  }

  function findMatchingVariant(options) {
    return variants.find(v =>
      v.options.every((opt, i) => opt === options[i])
    );
  }

  const quantityInput = document.querySelector('input[name="quantity"]');
  const inventoryInput = document.getElementById("SelectedVariantInventory");
  
  function checkQuantityAgainstInventory() {
    if (!quantityInput || !inventoryInput) return;
  
    const quantity = parseInt(quantityInput.value, 10) || 1;
    const inventory = parseInt(inventoryInput.value, 10) || 0;
  
    const submitBtn = document.querySelector('.product_form_available .product_add input[type="submit"]');
    if (!submitBtn) return;
  
    submitBtn.disabled = false;
    submitBtn.classList.remove('quant_threshold');
    submitBtn.value = 'Add to Cart';
  
    if (quantity > inventory) {
      console.log('⚠️ Not enough stock for selected quantity!');
      submitBtn.disabled = true;
      submitBtn.classList.add('quant_threshold');
      submitBtn.value = 'Insufficient Inventory';
    }
  }

  function checkFixedFormQuantityAgainstInventory() {
    const wrapper = document.querySelector('.quantity_dropdown_fixed');
    if (!wrapper) return;
  
    const quantityInput = wrapper.querySelector('input[name="quantity"]');
    const inventory = parseInt(document.getElementById("SelectedVariantInventory")?.value, 10) || 0;
    const quantity = parseInt(quantityInput.value, 10) || 1;
  
    const submitBtn = document.querySelector('.fixed_form_available .product_add input[type="submit"]');
  
    if (!submitBtn) return;
  
    submitBtn.disabled = false;
    submitBtn.classList.remove('quant_threshold');
    submitBtn.value = 'Add to Cart';
  
    if (quantity > inventory) {
      console.log('⚠️ Not enough stock for selected quantity in FIXED form!');
      submitBtn.disabled = true;
      submitBtn.classList.add('quant_threshold');
      submitBtn.value = 'Insufficient Inventory';
    }
  }

  document.querySelector('.product_form_available .product_add input[type="submit"]').addEventListener('click', function (e) {
        setTimeout(async function () {
          try {
            const vidEl = document.getElementById('SelectedVariantId');
            const invEl = document.getElementById('SelectedVariantInventory');
            if (!vidEl || !invEl) return;

            const variantId = parseInt(vidEl.value, 10);
            const inventory = parseInt(invEl.value, 10) || 0;

            const res = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!res.ok) return;
            const cart = await res.json();

            const item = cart.items.find(i => i.variant_id === variantId);
            const qtyInCart = item ? item.quantity : 0;

            const target = document.getElementById('maximum_quantity_in_cart');
            if (!target) return;

            if (qtyInCart === inventory) {
              target.style.display = 'block';
            }
          } catch (err) {
          }
        }, 200);
  });

  document.querySelector('span#cart_button_wrap').addEventListener('click', function (e) {
          setTimeout(async function () {
            const target = document.getElementById('maximum_quantity_in_cart');
            if (!target) return;
            target.style.display = 'none';
            console.log('CLICK!');
          }, 200);
  });
  
  quantityInput.addEventListener('change', checkQuantityAgainstInventory);
  quantityInput.addEventListener('input', checkQuantityAgainstInventory);


    function updateRecommendations(variantId) {
      const dataEl = document.getElementById('PdpRecsData');
      if (!dataEl) return;

      let recsData;
      try { recsData = JSON.parse(dataEl.textContent); } catch(e) { return; }

      const data = recsData[variantId] || recsData['default'];
      if (!data) return;

      function formatPrice(cents) {
        return Shopify.formatMoney(cents, moneyFormat).replace('.00', '');
      }

      const items = document.querySelectorAll('.pdp_recommendations_item');
      items.forEach(function(item, i) {
        if (i < data.length) {
          item.style.display = '';
          const rec = data[i];

          const link = item.querySelector('.pdp_recommendations_link');
          if (link) link.href = rec.url;

          const img = item.querySelector('.pdp_recommendations_image img');
          if (img) {
            img.src = rec.image;
            img.alt = rec.product_title;
          }

          const titleEl = item.querySelector('.pdp_recommendations_product_title');
          if (titleEl) titleEl.textContent = rec.product_title;

          const discount = parseFloat(rec.additional_discount) || 0;
          const price = rec.price;
          const compareAt = rec.compare_at_price;

          const hasAdditionalDiscount = discount > 0;
          const hasCompareAt = compareAt > 0 && compareAt > price;
          const showSale = hasAdditionalDiscount || hasCompareAt;

          const saleTag = item.querySelector('.pdp_recommendation_sale_tag');
          if (saleTag) {
            if (showSale) {
              if (hasAdditionalDiscount) {
                saleTag.textContent = discount + '% OFF';
              } else {
                saleTag.textContent = Math.round((compareAt - price) / compareAt * 100) + '% OFF';
              }
              saleTag.style.display = '';
            } else {
              saleTag.style.display = 'none';
            }
          }

          const priceEl = item.querySelector('.pdp_recommendations_variant_price');
          if (priceEl) {
            const strikeEl = priceEl.querySelector('s');
            const discountedEl = priceEl.querySelector('discounted-price');

            if (strikeEl) {
              if (showSale) {
                strikeEl.textContent = formatPrice(compareAt > 0 ? compareAt : price);
                strikeEl.style.display = '';
              } else {
                strikeEl.style.display = 'none';
              }
            }

            if (discountedEl) {
              if (showSale) {
                discountedEl.textContent = hasAdditionalDiscount
                  ? formatPrice(price * (1 - discount / 100))
                  : formatPrice(price);
                discountedEl.classList.add('discounted');
              } else {
                discountedEl.textContent = formatPrice(price);
                discountedEl.classList.remove('discounted');
              }
            }
          }

          const hiddenInput = item.querySelector('input[name="id"]');
          if (hiddenInput) hiddenInput.value = rec.variant_id;

          const atcBtn = item.querySelector('.pdp_recommendations_atc');
          if (atcBtn) atcBtn.setAttribute('data-variant-id', rec.variant_id);
        } else {
          item.style.display = 'none';
        }
      });

      const slider = document.querySelector('.pdp_recommendations');
      if (slider) {
        slider.scrollLeft = 0;
        requestAnimationFrame(function() {
          if (window.updateRecommendationArrows) window.updateRecommendationArrows();
        });
      }
    }

  function updateVariant() {
      const target = document.getElementById('maximum_quantity_in_cart');
      if (!target) return;
      target.style.display = 'none';

      const currentOptions = getSelectedOptions();
      const match = findMatchingVariant(currentOptions);
      if (match) {
        variantInput.value = match.id;

        updateRecommendations(match.id);
        updatePreorderProperty(match);
      
        const wrapper = document.querySelector('.estimated-ship-date');
        const waitEl = document.querySelector('wait-and-save');
        const dateEl = document.querySelector('ship-date');
        
        if (wrapper) {
          const rawDate = match.estimated_ship_date;
        
          if (rawDate) {
            const dateObj = new Date(rawDate + 'T00:00:00');
            const options = { month: 'long', day: 'numeric' };
            const formatted = dateObj.toLocaleDateString('en-US', options);
            
            if (dateEl) {
              dateEl.textContent = `Estimated to Ship ${formatted}`;
              dateEl.style.display = '';
            }
            wrapper.style.display = '';
          } else {
            if (dateEl) {
              dateEl.textContent = '';
              dateEl.style.display = 'none';
            }
            wrapper.style.display = 'none';
          }
        
          if (waitEl) {
            waitEl.style.display = parseFloat(match.additional_discount || 0) > 0 ? '' : 'none';
          }
        }
  
        const fixedVariantInput = document.querySelector('.fixed-variant-id');
        if (fixedVariantInput) {
          fixedVariantInput.value = match.id;
        }

        const preorderBtn = document.querySelector('.preorder_button');
        if (preorderBtn) {
          if (match.inventory_policy === 'continue') {
            preorderBtn.style.display = 'inline-block';
        
            const span1 = preorderBtn.querySelector('.preorder_text');
            const span2 = preorderBtn.querySelector('.preorder_subtext');
        
            if (span1) {
              const basePrice = match.price;
              const compareAt = match.compare_at_price;
              const extraDiscount = parseFloat(match.additional_discount || 0);
            
              // Determine what the reference price should be
              let referencePrice = compareAt > basePrice ? compareAt : basePrice;
            
              // Adjusted price always starts from the reference point
              let adjustedPrice = referencePrice;
              if (extraDiscount > 0) {
                adjustedPrice = referencePrice * (1 - extraDiscount / 100);
              }
            
              const compareHTML = referencePrice > adjustedPrice
                ? `<s class="inline_compare_price">${Shopify.formatMoney(referencePrice, moneyFormat).replace('.00', '')}</s> `
                : '';
            
              span1.innerHTML = `Add Pre-order <desktop-only style="display:none">TO CART</desktop-only> - ${compareHTML}<inline-sale-price>${Shopify.formatMoney(adjustedPrice, moneyFormat).replace('.00', '')}</inline-sale-price>`;
            }

        
            if (span2) {
              span2.innerHTML = (match.compare_at_price > match.price ? `Wait & Save:` : '') + ` Estimated to Ship Aug 14`;
            }
        
          } else {
            preorderBtn.style.display = 'none';
          }
        }
  
        // Handle notify button visibility and insertion
        const notifyWrapper = document.querySelector('.product_form_unavailable .product_add');
        const existingNotifyBtn = notifyWrapper?.querySelector('.notify_button');
        
        // Remove notify button if no form_id
        if (match.form_id) {
          if (!existingNotifyBtn) {
            const btn = document.createElement('button');
            btn.setAttribute('type', 'button');
            btn.className = 'notify_button';
            btn.innerHTML = '<span>Notify When Available</span>';
            notifyWrapper?.appendChild(btn);
          }
        } else if (existingNotifyBtn) {
          existingNotifyBtn.remove();
        }
  
        const fixedNotifyBtn = document.querySelector('.notify_button.fixed_form_unavailable');
        if (fixedNotifyBtn) {
          const span = fixedNotifyBtn.querySelector('span');
          if (match.form_id) {
            span.textContent = `Notify When Available`;
            fixedNotifyBtn.style.background = '';
            fixedNotifyBtn.style.color = '';
          } else {
            span.textContent = `Sold Out`;
            fixedNotifyBtn.style.background = '#999';
            fixedNotifyBtn.style.color = '#d9d9d9';
          }
        }
  
        const priceWrapper = document.querySelector('.product-price');
        
        if (priceWrapper) {
          priceWrapper.innerHTML = '';
        
          if (match.compare_at_price > match.price) {
            priceWrapper.classList.add('on-sale');
        
            const compareEl = document.createElement('s');
            compareEl.className = 'product-compare-price';
            compareEl.textContent = Shopify.formatMoney(match.compare_at_price, moneyFormat).replace('.00', '');
        
            const priceEl = document.createElement('span');
            priceEl.className = 'price-value';
            priceEl.textContent = Shopify.formatMoney(match.price, moneyFormat).replace('.00', '');
        
            const savingsBox = document.createElement('span');
            savingsBox.className = 'savings_box';
            const savings = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            savingsBox.textContent = `${savings}% Off Sale`;
        
            priceWrapper.appendChild(compareEl);
            priceWrapper.appendChild(priceEl);
            priceWrapper.appendChild(savingsBox);
          } else {
            priceWrapper.classList.remove('on-sale');
        
            const priceEl = document.createElement('span');
            priceEl.className = 'price-value';
            priceEl.textContent = Shopify.formatMoney(match.price, moneyFormat).replace('.00', '');
        
            priceWrapper.appendChild(priceEl);
          }
        }

        const preorderInlinePrice = document.querySelector('.preorder_inline_price');
        
        if (preorderInlinePrice) {
          const compareEl = preorderInlinePrice.querySelector('.inline_compare_price');
          const priceEl = preorderInlinePrice.querySelector('inline-sale-price');
        
          if (compareEl && priceEl) {
            const extraDiscount = parseFloat(match.additional_discount || 0);
            const basePrice = match.price;
            let adjustedPrice = basePrice;
          
            if (extraDiscount > 0) {
              adjustedPrice = basePrice * (1 - extraDiscount / 100);
            }
          
            let referencePrice = basePrice;
            if (match.compare_at_price > basePrice) {
              referencePrice = match.compare_at_price;
            }
          
            const showCompare = referencePrice > adjustedPrice;
          
            if (showCompare) {
              compareEl.textContent = Shopify.formatMoney(referencePrice, moneyFormat).replace('.00', '');
              compareEl.style.display = '';
            } else {
              compareEl.textContent = '';
              compareEl.style.display = 'none';
            }
          
            priceEl.textContent = Shopify.formatMoney(adjustedPrice, moneyFormat).replace('.00', '');
          }
        
          if (priceEl) {
            const extraDiscount = parseFloat(match.additional_discount || 0);
            const basePrice = match.price;
            let adjustedPrice = basePrice;
          
            if (extraDiscount > 0) {
              adjustedPrice = basePrice * (1 - extraDiscount / 100);
            }
          
            priceEl.textContent = Shopify.formatMoney(adjustedPrice, moneyFormat).replace('.00', '');
          }
        }

        const newUrl = `${window.location.pathname}?variant=${match.id}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
  
        const formPairs = [
          ['.product_form_available', '.product_form_unavailable'],
          ['.fixed_form_available', '.fixed_form_unavailable']
        ];
        
        formPairs.forEach(([availableSelector, unavailableSelector]) => {
          const availableForm = document.querySelector(availableSelector);
          const unavailableForm = document.querySelector(unavailableSelector);
        
          if (availableForm && unavailableForm) {
            if (match.inventory_quantity > 0) {
              availableForm.style.display = '';
              unavailableForm.style.display = 'none';
            } else {
              availableForm.style.display = 'none';
              unavailableForm.style.display = '';
            }
          }
        });

        const selectorWrapper = document.querySelector('.product_form_selectors');
        if (selectorWrapper) {
          selectorWrapper.style.display = 'flex';
        }

        // Toggle delivery estimate visibility
        const deliverySpan = document.querySelector('delivery-date')?.closest('span');
        if (deliverySpan) {
          deliverySpan.style.display = match.inventory_quantity > 0 ? '' : 'none';
        }
  
        const notifyBtns = document.querySelectorAll('.notify_button');
        const preselectedId = document.getElementById('preSelectedVariantId')?.value;
        
        if (match.form_id && match.id.toString() !== preselectedId) {
          notifyBtns.forEach((btn) => {
            btn.onclick = function () {
              window._klOnsite = window._klOnsite || [];
              window._klOnsite.push(['openForm', match.form_id]);
            };
          });
        }

        const inventoryInput = document.getElementById("SelectedVariantInventory");
        if (inventoryInput) {
          inventoryInput.value = match.inventory_quantity || 0;
        }
        enforceCartCapForVariant(match);
        checkQuantityAgainstInventory();
        
      } else {
        variantInput.value = "";
      }
      checkFixedFormQuantityAgainstInventory();
      setTimeout(() => { if (window.updateGalleryButton) window.updateGalleryButton(); }, 500);

    }


  // Quantity controls
  document.addEventListener('click', function (e) {
    if (e.target.closest('.button-plus')) {
      const input = e.target.closest('.input-group').querySelector('.quantity-field');
      let val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    }

    if (e.target.closest('.button-minus')) {
      const input = e.target.closest('.input-group').querySelector('.quantity-field');
      let val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    }
  });

  // Quantity dropdown accessibility

  document.addEventListener('keydown', function (e) {
    const selected = document.activeElement.closest('.quantity_dropdown_selected');
    const wrapper = selected?.closest('.quantity_dropdown_wrapper');
  
    if (!selected || !wrapper) return;
  
    // Open or close dropdown with Enter or Space
    if ((e.key === 'Enter' || e.key === ' ') && !wrapper.classList.contains('open')) {
      e.preventDefault();
      wrapper.classList.add('open');
    }
  
    // Optional: close on Escape
    if (e.key === 'Escape') {
      wrapper.classList.remove('open');
      selected.blur();
    }
  });

  // Quantity dropdown

  document.addEventListener('keydown', function (e) {
    const wrapper = document.activeElement.closest('.quantity_dropdown_wrapper');
    if (!wrapper || !wrapper.classList.contains('open')) return;
  
    const options = Array.from(wrapper.querySelectorAll('.quantity_dropdown_option'));
    const focused = document.activeElement;
  
    // Find the currently focused option, if any
    const currentIndex = options.indexOf(focused);
  
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = options[currentIndex + 1] || options[0];
      next.focus();
    }
  
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = options[currentIndex - 1] || options[options.length - 1];
      prev.focus();
    }
  
    if (e.key === 'Enter' && focused.classList.contains('quantity_dropdown_option')) {
      e.preventDefault();
      focused.click(); // triggers your existing selection logic
    }
  });

  // Quantity dropdown control
  document.addEventListener('change', function (e) {
    const dropdown = e.target.closest('.quantity_dropdown');
    if (dropdown) {
      const new_quantity = parseInt(dropdown.value, 10);
      // Optional: custom behavior if needed
      console.log('Dropdown quantity selected:', new_quantity);
    }
  });

  document.addEventListener('click', function (e) {
    const allWrappers = document.querySelectorAll('.quantity_dropdown_wrapper');
    const clickedWrapper = e.target.closest('.quantity_dropdown_wrapper');

    console.log('clickedWrapper is:', clickedWrapper);
  
    allWrappers.forEach(wrapper => {
      if (wrapper !== clickedWrapper) {
        wrapper.classList.remove('open');
      }
    });
  
    if (!clickedWrapper) return;
  
    const option = e.target.closest('.quantity_dropdown_option');
    if (option) {
      const selectedVal = option.getAttribute('data-value');
      clickedWrapper.querySelector('.quantity_dropdown_selected').textContent = selectedVal;
      clickedWrapper.querySelector('input[name="quantity"]').value = selectedVal;
    if (clickedWrapper.classList.contains('quantity_dropdown_fixed')) {
      checkFixedFormQuantityAgainstInventory();
    }

      checkQuantityAgainstInventory();
      clickedWrapper.classList.remove('open');
      return;
    }

    
  
    clickedWrapper.classList.toggle('open');
  });

  // Variant setup on load
  setTimeout(function () {
    const variantIdFromURL = getVariantIdFromURL();
    
    if (variantIdFromURL) {
      let matchedVariant = variants.find(v => v.id == variantIdFromURL);
    
      // Skip USA-only variants (if they were excluded from rendering)
      if (matchedVariant && matchedVariant.options && matchedVariant.id) {
        matchedVariant.options.forEach((opt, i) => {
          const radio = document.querySelector(`input[name="option-${i}"][value="${opt}"]`);
          if (radio) radio.checked = true;
        });
    
        variantInput.value = matchedVariant.id;
    
        if (parseInt(variantIdFromURL, 10) !== defaultVariantId) {
          // Different from default → let updateVariant handle everything
          updateVariant(); // calls updatePreorderProperty(matchedVariant)
        } else {
          // URL variant == defaultVariant → still sync preorder property
          updatePreorderProperty(matchedVariant);
          updateRecommendations(matchedVariant.id);
        }
      } else {
        // Fallback if excluded
        const fallbackVariant = variants[0];
        if (fallbackVariant) {
          fallbackVariant.options.forEach((opt, i) => {
            const radio = document.querySelector(`input[name="option-${i}"][value="${opt}"]`);
            if (radio) radio.checked = true;
          });
    
          variantInput.value = fallbackVariant.id;
          updateVariant(); // calls updatePreorderProperty(fallbackVariant)
        }
      }
    } else {
      // No variant in URL → use default variant and sync preorder property
      variantInput.value = defaultVariantId;

      const defaultVariant = variants.find(v => v.id === defaultVariantId);
      const inventoryInput = document.getElementById("SelectedVariantInventory");
      
      if (defaultVariant && inventoryInput) {
        inventoryInput.value = defaultVariant.inventory_quantity || 0;
      }

      if (defaultVariant) {
        updatePreorderProperty(defaultVariant);
        updateRecommendations(defaultVariant.id);
      }
    }
    
    document.querySelectorAll('[name^="option-"]').forEach(input => {
      input.addEventListener("change", updateVariant);
    });
  }, 0);

  
});

// ---- shared button logic (desktop + mobile) ----
(function () {
  function isVisible(el){ return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function isVideo(el){ return !!(el && (el.classList?.contains('product_video') || el.querySelector?.('video'))); }
  function normalize(u){ return (u||'').replace(/^https?:/,'').split('?')[0]; }

  window.updateGalleryButton = function () {
    const btns = document.querySelectorAll('.gallery_overlap_button');
    if (!btns.length) return;

    // second visible DESKTOP thumb
    const deskVisible = Array.from(document.querySelectorAll('.product_thumbnail_grid .product_media')).filter(isVisible);
    const secondDesk = deskVisible[1];

    // second visible MOBILE slide
    let mobileVisible = Array.from(document.querySelectorAll('#viewport_scroll li.carousel__slide.visible_cell'));
    if (!mobileVisible.length) mobileVisible = Array.from(document.querySelectorAll('#viewport_scroll li.carousel__slide')).filter(isVisible);
    const secondMobile = mobileVisible[1];

    const secondIsVideo = isVideo(secondDesk) || isVideo(secondMobile);

    // first slide active? (mobile bullets or scrollLeft≈0)
    let firstActive = false;
    const ab = document.getElementById('active_bullet');
    if (ab && ab.value === '1') firstActive = true;
    else {
      const vp = document.querySelector('.carousel__viewport');
      if (vp && vp.scrollLeft <= 1) firstActive = true;
    }

    // desktop fallback: featured equals first visible thumb
    if (!firstActive && deskVisible[0]) {
      const firstDesk = deskVisible[0];
      const featuredVid = document.querySelector('.product_featured_media_video');
      const featuredImg = document.querySelector('.product_featured_media_image');
      const current = (featuredVid && isVisible(featuredVid))
        ? (featuredVid.querySelector('source')?.src || '')
        : (featuredImg?.src || '');
      const firstSrc = firstDesk.dataset.videoSrc
        || firstDesk.dataset.imgUrl
        || firstDesk.querySelector('video source')?.src
        || firstDesk.querySelector('video')?.src
        || '';
      if (normalize(firstSrc) === normalize(current)) firstActive = true;
    }

    const show = firstActive && secondIsVideo;
    btns.forEach(b => b.style.display = show ? '' : 'none');
  };

  // run once after layout settles
  window.addEventListener('load', () => setTimeout(window.updateGalleryButton, 150));
})();
